/**
 * Accessibility: Skip-to-content link.
 *
 * Visually hidden by default; appears at the top-left when focused via Tab.
 * Lets keyboard / screen-reader users bypass the header + nav and jump
 * straight to the main content. ADA / WCAG 2.1 success criterion 2.4.1.
 */
export default function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-md focus:bg-primary focus:text-primary-foreground focus:font-bold focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
    >
      Skip to main content
    </a>
  );
}
